import React from 'react';
import { beautifyNumber } from '../../../../Utils/FormatNumber';
import styles from '../ReportModalXtram.module.scss';

const AccumulatedVatPanel = ({ t, accumulatedVat }) => {
    if (!accumulatedVat) return null;

    const items = [
        { label: t('TransactionsVATDifference'), value: accumulatedVat.vatTransactions },
        { label: t('EquipmentVATDifference'), value: accumulatedVat.equipmentVAT },
        { label: t('OtherInputsVATDifference'), value: accumulatedVat.otherVATTaxes },
        { label: t('TotalDifference'), value: accumulatedVat.netVAT, isTotal: true },
    ];

    return (
        <div className={styles.panel}>
            <div className={styles.panelHeader}>{t('AccumulatedDifferenceInVat')}</div>
            <table className={styles.kvTable}>
                <tbody>
                    {items.map((item) => (
                        <tr key={item.label} className={item.isTotal ? styles.kvTotal : undefined}>
                            <th scope="row">{item.label}</th>
                            <td className={item.value >= 0 ? styles.positive : styles.negative}>
                                {beautifyNumber(item.value)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AccumulatedVatPanel;
